import React from 'react'
import Base from '../base'

// 九宫格布局
export default class Sudoku extends Base {
  render() {
    return (
      <div className="section-collection-articles articles-layout-sudoku">
        <div className="container">
          <div className="row">
            {this.state.articles.map((article, index) =>
              <div className="col-sm-3" key={"article-" + article.guid + index}>
                <div className="collection-article-item">
                  <div className="collection-article-cover">
                    {
                      (article.cover || {}).url &&
                      <img src={article.cover.url + "?imageMogr2/format/jpeg/thumbnail/x600>"} />
                    }
                  </div>
                  <div className="collection-article-info">
                    <a href={article.path || ""}>{article.title}</a>
                  </div>
                </div>
              </div>
            )}

            {super.render()}
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/collection/articles/sudoku/index.js